import { PageController } from '@client/components/_core/layout/PageController';
import { VehicleTab } from '@client/components/claims/vehicle/VehicleTab';
import { createFileRoute } from '@tanstack/react-router';
import { claimFormStore } from '../store';

/**
 * Replaces the former separate vehicle-inspection and vehicle-assessment tabs. Deliberately
 * carries no `featureFlag` in staticData: the tab is gated on the claim's product-type
 * category, and only the AI-scan *section* inside is flag-gated — a route-level flag would
 * also hide the (unflagged) repair assessment.
 */
export const Route = createFileRoute('/console/$orgId/claims/details/$id/vehicle')({
    staticData: {
        metadata: {
            title: 'Vehicle',
        },
    },
    beforeLoad: ({ context, params }): void => {
        // Remove the claim-to-vehicle waterfall during route loading. Fire-and-forget intentionally;
        // failed cache warm-ups fall through to the render-time queries and their existing error handling.
        void context.trpcUtils.claim.getClaim.ensureData({ id: params.id }).catch(() => undefined);
        void context.trpcUtils.vehicleInspection.listForClaim.prefetch(
            { claimId: params.id },
            { retry: 1, staleTime: 60_000 },
        );
        void context.trpcUtils.vehicleAssessment.getForClaim.prefetch(
            { claimId: params.id },
            { retry: 1, staleTime: 30_000 },
        );
    },
    component: VehicleRoute,
});

function VehicleRoute() {
    const claim = claimFormStore.use.formData();

    return <PageController route={Route}>{claim && <VehicleTab claimId={BigInt(claim.id)} />}</PageController>;
}
